import React from 'react'
import { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'
import { tv } from 'tailwind-variants'

import { CardSize } from '@/types/ui'

const headerVariants = tv({
  base: 'flex flex-col gap-x-2 z-1 absolute inset-x-0 from-black to-transparent group-hover:h-[100%] transition-all duration-[800ms]',
  variants: {
    position: {
      top: 'top-0 bg-gradient-to-b',
      bottom: 'bottom-0 bg-gradient-to-t justify-end',
      left: 'left-0 bg-gradient-to-r justify-end',
    },
    overlayHeight: {
      quarter: 'h-[25%]',
      half: 'h-[50%]',
      threeQuarter: 'h-[75%]',
      max: 'h-[100%]',
    },
    overlayWidth: {
      quarter: 'w-[25%]',
      half: 'w-[50%]',
      threeQuarter: 'w-[75%]',
      max: 'w-[100%]',
    },
    size: {
      sm: 'pb-5 px-5',
      md: 'pb-6 px-6',
      lg: 'pb-8 px-8',
      xl: 'pb-10 px-10',
      default: 'pb-6 px-6',
    },
  },
  compoundVariants: [
    {
      size: 'lg',
      position: 'top',
      className: 'pt-12',
    },
  ],
  defaultVariants: {
    position: 'bottom',
    overlayHeight: 'max',
    overlayWidth: undefined,
    size: 'lg',
  },
})

export interface CardOverlayProps {
  position?: 'top' | 'bottom' | 'left'
  overlayHeight?: 'quarter' | 'half' | 'threeQuarter' | 'max' | undefined
  overlayWidth?: 'quarter' | 'half' | 'threeQuarter' | 'max' | undefined
  size?: CardSize
  className?: string
  children?: ReactNode
}

export const CardOverlay: React.FC<CardOverlayProps> = ({
  position = 'bottom',
  overlayHeight = 'half',
  overlayWidth,
  size = 'lg',
  className,
  children,
}) => (
  <div
    className={twMerge(
      headerVariants({ position, overlayHeight, overlayWidth, size }),
      className,
    )}
  >
    {children}
  </div>
)

export default CardOverlay
